import { useState } from "react";
import { ShieldCheck } from "lucide-react";
import { checkEmail } from "@/lib/deliverability";
import { cn } from "@/lib/utils";

export const Deliverability = ({ subject, body, id }) => {
  const [open, setOpen] = useState(false);
  const r = checkEmail(subject, body);
  const tone = r.score >= 85 ? "border-emerald-500/40 text-emerald-300" : r.score >= 60 ? "border-amber-500/40 text-amber-300" : "border-red-500/40 text-red-300";
  return (
    <div data-testid={`${id}-check`}>
      <button onClick={() => setOpen(!open)} className={cn("flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-[10px]", tone)} data-testid={`${id}-check-toggle`}>
        <ShieldCheck className="h-3 w-3" />{r.label} · {r.score}<span className="text-zinc-500">· {r.words} words · grade {r.grade}</span>
      </button>
      {open && <ul className="mt-1.5 space-y-0.5 rounded-lg bg-[#121215] p-2 text-[11px] text-zinc-400" data-testid={`${id}-check-issues`}>
        {r.issues.length ? r.issues.map((x) => <li key={x}>• {x}</li>) : <li className="text-emerald-300">Looks human, short and inbox-friendly.</li>}
      </ul>}
    </div>
  );
};
